import { Box } from "@mui/material";
import { primaryGradient } from "../../theme";
import Speciality from "../../models/Speciality";

interface SpecialityOptionProps {
  speciality: Speciality;
  centered?: boolean;
  selected: boolean;
  setSelected: (speciality: string) => void;
}

export default function SpecialityOption({ speciality, centered, selected, setSelected }: SpecialityOptionProps) {
  return (
    <Box
      sx={{
        background: selected ? primaryGradient : "white",
        color: selected ? "white" : undefined,
        borderRadius: 1.5,
        py: 2,
        px: 4,
        boxShadow: '0px 0px 22px 0px #97979765',
        height: "100%",
        display: 'flex',
        alignItems: 'center',
        justifyContent: centered ? "center" : undefined,
        fontWeight: 500,
        cursor: "pointer",
      }}
      onClick={() => setSelected(speciality.id)}
    >
      {speciality.name}
    </Box>
  )
}